export default __webpack_public_path__ + "static/media/NIAS0470.34I-34794_-25718_0.25f20db9.jpg";